<template>
  <div class="fixed flex flex-col justify-center items-left  w-9/12 shadow-xl z-40 rounded-2xl bg-white pt-4">
    <span class="mb-2 ml-6 text-sm text-yank">{{loadingText ? loadingText : 'Uploading your post'}}</span>
    <div class="h-full mr-8 overflow-hidden pb-2">   
        <loading-progress
            :indeterminate="true"
            fillDuration="2"
            height="20"
            :size="loadingBarSize"
        />
    </div>
</div>
</template>

<script>
export default {
    name:"LoadingModal",

    props: {
        loadingText: {
            type: String,
            required:true 
        },

        loadingBarSize: {
            type: Number,
            default: 1000
        }
    },
}
</script>
